var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonepay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7718 8.68598C21.7718 7.98352 21.1759 7.3814 20.4807 7.3814H18.0972L12.635 1.05921C12.1385 0.4571 11.344 0.256396 10.5495 0.4571L8.66255 1.05921C8.36461 1.15957 8.2653 1.56097 8.46392 1.76168L14.4227 7.48175H5.38523C5.0873 7.48175 4.88867 7.68246 4.88867 7.98352V8.98704C4.88867 9.6895 5.48455 10.2916 6.17973 10.2916H7.57011V15.1085C7.57011 18.7212 9.45704 20.8286 12.635 20.8286C13.6282 20.8286 14.4227 20.7282 15.4158 20.3268V23.5381C15.4158 24.4413 16.111 25.1437 17.0048 25.1437H18.3952C18.6931 25.1437 18.991 24.8427 18.991 24.5416V10.1913H21.2752C21.5732 10.1913 21.7718 9.99056 21.7718 9.6895V8.68598ZM15.4158 17.3163C14.8199 17.6173 14.0254 17.7177 13.4295 17.7177C11.8405 17.7177 11.046 16.9149 11.046 15.1085V10.2916H15.4158V17.3163Z",
    fill: "#5F259F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonepay);
export default __webpack_public_path__ + "static/media/phonepay.d383cf82602810a87399aa813718a523.svg";
export { ForwardRef as ReactComponent };